import React from "react";
import {
  FaExchangeAlt,
  FaBolt,
  FaUserAlt,
  FaLink,
  FaChartLine,
  FaCoins,
} from "react-icons/fa";

function TraditionalOrder() {
  return (
    <div>
      <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">What we do</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Key Features of Order Book DEX Developed by Xeer Technology
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              {/* 1 */}
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item">
                  <div className="top-info">
                    <FaExchangeAlt size={45} className="mb-3 text-primary" />
                    <h4>Traditional Order Book Functionality</h4>
                    <p>
                      Our DEXs mimic traditional exchange mechanisms, allowing
                      users to place limit orders, market orders, and stop-loss
                      orders, enhancing trading flexibility and user control.
                    </p>
                  </div>
                </div>
              </div>

              {/* 2 */}
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaBolt size={45} className="mb-3 text-primary" />
                    <h4>Real-Time Order Matching</h4>
                    <p>
                      With efficient order matching algorithms, our Order Book
                      DEXs ensure fast and reliable execution of trades,
                      minimizing latency and providing users with a seamless
                      trading experience.
                    </p>
                  </div>
                </div>
              </div>

              {/* 3 */}
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaUserAlt size={45} className="mb-3 text-primary" />
                    <h4>User-Friendly Interface</h4>
                    <p>
                      We design intuitive user interfaces that simplify the
                      trading process, making it easy for both novice and
                      experienced traders to navigate the platform and execute
                      trades.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row pt-4">
              {/* 4 */}
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item">
                  <div className="top-info">
                    <FaLink size={45} className="mb-3 text-primary" />
                    <h4>Cross-Chain Compatibility</h4>
                    <p>
                      Our Order Book DEXs can facilitate trades across multiple
                      blockchain networks, allowing users to trade a wide range
                      of assets and improving liquidity.
                    </p>
                  </div>
                </div>
              </div>

              {/* 5 */}
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaChartLine size={45} className="mb-3 text-primary" />
                    <h4>Advanced Trading Features</h4>
                    <p>
                      We incorporate features such as limit and stop orders,
                      order history, and trade analytics to provide users with
                      comprehensive tools for effective trading strategies.
                    </p>
                  </div>
                </div>
              </div>

              {/* 6 */}
              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaCoins size={45} className="mb-3 text-primary" />
                    <h4>Liquidity Incentives</h4>
                    <p>
                      To attract liquidity providers, our DEXs offer rewards for
                      market makers and liquidity suppliers, enhancing liquidity
                      depth and improving trading conditions for all users.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TraditionalOrder;
